"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.STOP_DICTATE = void 0;
var STOP_DICTATE = 'WEB_CHAT/STOP_DICTATE';
exports.STOP_DICTATE = STOP_DICTATE;

function _default() {
  return {
    type: STOP_DICTATE
  };
}